module.exports = __webpack_public_path__ + "fonts/_VYFx-s824kXq_Ul2BHqYH-_kf6ByYO6CLYdB4HQE-Y.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/_VYFx-s824kXq_Ul2BHqYH-_kf6ByYO6CLYdB4HQE-Y.woff2
// module id = 328
// module chunks = 0